import React from "react";
import {
  Timeline,
  TimelineHeader,
  TimelineTitle,
  TimelineSubtitle,
  TimelineMain,
  TimelineSteps,
} from "raffle-house-uikit";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { getCharityLightLogoUrl } from "../../helpers/getCharityLogoUrl";

import "./styles.scss";

const TimelineBlock = (props) => {
  const { content } = props;
  // const mobile = useMediaQuery("(max-width: 560px)");
  // const laptop = useMediaQuery("(max-width: 1024px)");
  // const title = laptop ? data.horizontal.title : data.vertical.title;
  // const subtitle = mobile ? data.horizontal.subtitle : data.vertical.subtitle;

  const charityLogo = getCharityLightLogoUrl(process.env.REACT_APP_CHARITY_NAME);
  const charityName = process.env.REACT_APP_CHARITY_NAME;

  // useGSAP(() => !mobile && startHeaderAnimation());
  // useGSAP(
  //   () => {
  //     !mobile &&
  //       startBadgeAnimation({
  //         numberOfSteps: data.vertical.steps.length,
  //         images: (widget && widget.images) || [],
  //       });
  //   },
  //   { dependencies: [mobile, widget] }
  // );
  return (
    <Timeline>
      <TimelineHeader badgeText={content.specialBadge}>
        <TimelineTitle>{content.title}</TimelineTitle>
        <TimelineSubtitle>{content.description}</TimelineSubtitle>
      </TimelineHeader>
      <TimelineMain>
        <TimelineSteps
          steps={content.stepper}
        />
        <div className="timeline-block-footer">
          <h3 className="timeline-block-footer__header">
            Supporting {charityName}
          </h3>
          <img
            className="timeline-block-footer__img"
            src={charityLogo}
            alt={charityName}
          />
          <p className="timeline-block-footer__text">
            Every time you enter, you'll be supporting {charityName}.<br/>
            It's time to dream big and do good.
          </p>
        </div>
      </TimelineMain>
    </Timeline>
  );
};

export default TimelineBlock;
